import pyClient from '../PyAPI_Config'
import { GridPaginationModel } from '@mui/x-data-grid-pro'
import { tsGetLimsSampleFilters } from '../../../Typescript/UI_Interfaces'

async function createLimesIssue(authState: any, fields: object) {
  return await pyClient(authState)
    .post<any>('/lims/issue', fields)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function getLimsSamples(
  authState: any,
  filters: tsGetLimsSampleFilters & GridPaginationModel,
) {
  const filterOwner =
    filters?.lims_owner_entity_id ?
      `&lims_owner_entity_id=${filters.lims_owner_entity_id}`
    : ''
  const filterType =
    filters?.sample_type ? `&sample_type=${filters.sample_type}` : ''
  const filterDetail =
    filters?.sample_detail ? `&sample_detail=${filters.sample_detail}` : ''
  const filterSex = filters?.sex ? `&sex=${filters.sex}` : ''
  const filterLine =
    filters?.short_line_name ?
      `&short_line_name=${filters.short_line_name}`
    : ''

  return await pyClient(authState)
    .get<any>(
      `/lims/samples?category=${filters.category}` +
        filterOwner +
        filterType +
        filterDetail +
        filterSex +
        filterLine,
      {
        headers: { 'x-page': filters.page + 1, 'x-per-page': filters.pageSize },
      },
    )
    .catch((error) => Promise.reject(error.response))
}

async function getPricebook(authState: any, category: string) {
  return await pyClient(authState)
    .get<any>(`/pricebook/${category}`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

const LimsService = {
  getLimsSamples,
  createLimesIssue,
  getPricebook,
}

export default LimsService
